import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Home = () => {
  const [block1Value, setBlock1Value] = useState("");
  const [block2Value, setBlock2Value] = useState("");
  const [block3Value, setBlock3Value] = useState("");
  const [submitEnabled, setSubmitEnabled] = useState(false);

  const handleBlock1Change = (event) => {
    setBlock1Value(event.target.value);
    checkSubmitEnable();
  };

  const handleBlock2Change = (event) => {
    setBlock2Value(event.target.value);
    checkSubmitEnable();
  };

  const handleBlock3Change = (event) => {
    setBlock3Value(event.target.value);
    checkSubmitEnable();
  };

  const checkSubmitEnable = () => {
    if (block1Value !== "" && block2Value !== "" && block3Value !== "") {
      setSubmitEnabled(true);
    } else {
      setSubmitEnabled(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(
      `House Type: ${block1Value}\nSize of House: ${block2Value} m2\nAddress: ${block3Value}\nEstimate price: 15000€, Estimate saving: 9500€`
    );
  };

  return (
    <div
      className="flex flex-col items-center justify-between min-h-screen bg-gray-800"
      style={{
        backgroundImage: `url(${require("../assets/background.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Header />
      <div className="flex flex-col items-center justify-center w-[80%] px-5 py-24">
        <div
          className="container"
          style={{ display: "flex", alignItems: "center" }}
        >
          <form
            className="search-form"
            style={{ display: "flex" }}
            onSubmit={handleSubmit}
          >
            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#333",
                color: "#fff",
                padding: "20px",
                marginRight: "10px",
                borderRadius: "5px",
                position: "relative",
                width: "200px",
              }}
            >
              <label
                htmlFor="desired-orbit"
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  marginBottom: "5px",
                }}
              >
                Desired Orbit
              </label>
              <select
                id="desired-orbit"
                name="desired-orbit"
                onChange={handleBlock1Change}
                value={block1Value}
                style={{
                  background: "none",
                  border: "none",
                  color: "#fff",
                  fontSize: "16px",
                  padding: "5px",
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  position: "relative",
                  zIndex: "1",
                }}
              >
                <option value="SSO">SSO</option>
                <option value="LEO">LEO</option>
                <option value="POLAR">POLAR</option>
              </select>
              <span
                className="icon"
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontSize: "24px",
                  pointerEvents: "none",
                }}
              >
                &#9662;
              </span>
            </div>
            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#333",
                color: "#fff",
                padding: "20px",
                marginRight: "10px",
                borderRadius: "5px",
                position: "relative",
                width: "200px",
              }}
            >
              <label
                htmlFor="launch-date"
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  marginBottom: "5px",
                }}
              >
                No Earlier Than
              </label>
              <input
                type="text"
                id="launch-date"
                name="launch-date"
                placeholder="09/2024"
                onChange={handleBlock2Change}
                value={block2Value}
                style={{
                  background: "none",
                  border: "none",
                  color: "#fff",
                  fontSize: "24px",
                }}
              />
              <span
                className="icon"
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontSize: "24px",
                  pointerEvents: "none",
                }}
              >
                &#128197;
              </span>
            </div>
            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#333",
                color: "#fff",
                padding: "20px",
                marginRight: "10px",
                borderRadius: "5px",
                position: "relative",
                width: "200px",
              }}
            >
              <label
                htmlFor="payload-mass"
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  marginBottom: "5px",
                }}
              >
                Input Payload Mass
              </label>
              <input
                type="text"
                id="payload-mass"
                name="payload-mass"
                placeholder="kg"
                onChange={handleBlock3Change}
                value={block3Value}
                style={{
                  background: "none",
                  border: "none",
                  color: "#fff",
                  fontSize: "24px",
                }}
              />
            </div>
            <button
              type="submit"
              className="search-button"
              disabled={!submitEnabled}
              style={{
                backgroundColor: "#000",
                color: "#fff",
                border: "none",
                padding: "20px",
                borderRadius: "5px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "85px",
              }}
            >
              <span className="arrow-icon" style={{ fontSize: "24px" }}>
                &#10132;
              </span>
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
